import { api } from '@/api/api';
import { apis } from '@/config';
import { ContactTransformInstance } from '../contact/contact_transform';
export class MailCustomerHelper {
    constructor() {
        this.contactTrans = ContactTransformInstance;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.customerApi = api.requireLogicalApi(apis.customerApiImpl);
    }
    findCustomerManager(it) {
        var _a, _b;
        const currentUser = this.systemApi.getCurrentUser();
        const currentContactId = ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || ((_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _b === void 0 ? void 0 : _b.contactId);
        return Array.isArray(it.managerList) ? it.managerList.find(v => v.managerId === currentContactId) : null;
    }
}
